import React from 'react';
import { connect } from 'react-redux';
import { getUser, me, shareProject, resetPasswd } from '../../api/user';
import styles from './mine.css';
import bindAll from "lodash.bindall";
import qs from "qs";
import Page from '../../components/page/page';
import { setUser } from '../../reducers/teach';
import message from "../../components/message/message";
import Project from '../../components/project-list/project-transform';
import Pagination from 'rc-pagination';
import ModalManager from '../../components/modal/modal-manager'
import TipsModal from '../../components/modal/remove-modal';


class MinePage extends React.PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            'onChange',
            'getProject'
        ]);
        this.query = qs.parse(location.search, { ignoreQueryPrefix: true });
        this.state = {
            ProjectListData: [],
            current: 1,
            total: null,
            pageSize: 15
        }
    }

    componentDidMount() {
        this.getUser();
    }

    getUser() {
        if (this.query.pid) {
            getUser({ id: this.query.pid }, { quiet: !!this.props.username }).then(res => {
                this.props.setUser(res)
            }).then(() => {
                this.getProject();
            });
        } else {
            me({}, { quiet: !!this.props.username }).then(res => {
                this.props.setUser(res)
            }).then(() => {
                this.getProject();
            });
        }
    }

    getProject() {
        const { current, pageSize } = this.state
        shareProject({ user_id: this.props.user.id, page_size: pageSize, page: current }, { quiet: true }).then(res => {
            this.setState({
                ProjectListData: res.data,
                total: res.total
            })
        });
    }

    //手机号隐藏处理
    getTel(tel) {
        if (tel) {
            if (tel.length === 12) {
                const reg = /^(\d{3})\d{4}(\d{5})$/;
                return tel.replace(reg, "$1****$2");
            }
            const reg = /^(\d{3})\d{4}(\d{4})$/;
            return tel.replace(reg, "$1****$2");
        }
    }

    onChange(page) {
        this.setState({
            current: page,
        }, () => {
            this.getProject()
        })
    };

    // 重置密码
    onReset() {
        const { user } = this.props;
        ModalManager.open(TipsModal, {
            title: '重置密码',
            onClose: () => { },
            onSubmit: () => {
                resetPasswd({
                    password: "abc123",
                    password_confirmation: "abc123",
                    clazz_id: this.query.cid,
                    user_id: user.id
                }, { quiet: false }).then(res => {
                    if(res){
                        ModalManager.pop();
                        message('重置成功');
                    }
                })
            },
            content: "是否确认重置学生密码？重置后密码将改为'abc123'。"
        })
    }


    render() {
        const { user } = this.props;
        const { ProjectListData, current, total, pageSize } = this.state;
        const identity = this.query.cid;
        return (
            <Page isModal={true} title={window.L("teach.user.mine")}>
                <div className={styles.profileBox}>
                    <div className={styles.bg}></div>
                    <div className={styles.contentBox}>
                        <div className={styles.hreader}>
                            <div className={styles.userHead}>
                                <img src={window.config.staticURL + '/avatar/' + (user.avatar || 'default.png')} />
                                <div className={styles.username}>
                                    <p>{user.name}</p>
                                    <span>{identity ? user.phone : this.getTel(user.phone)}</span>
                                </div>
                            </div>
                            <div>{identity && <span className={styles.reset} onClick={()=>this.onReset()}>重置密码</span>}</div>
                        </div>
                        <div className={styles.myShare}>
                            <h3>公开作品</h3>
                            <div>
                                <Project
                                    data={ProjectListData}
                                    share={true}
                                    linkType='share'
                                    userShow={true}
                                    userInfo={user}
                                />
                            </div>
                            <div className={styles.pagination}>
                                <Pagination
                                    current={current}
                                    defaultPageSize={pageSize}
                                    total={total}
                                    onChange={this.onChange}
                                ></Pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </Page>
        );
    }
}

const mapStateToProps = state => ({
    user: state.teach.user
});


const mapDispatchToProps = dispatch => ({
    setUser: res => dispatch(setUser(res)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MinePage);
